export default function validationFace(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FORBIDDEN_TO_ARCHIVE_FACE_WITH_ETAT_DIFF_DEMONTE') === 0) {
      messages.push({ message: 'detailFace.messages.error.faceEtatDiffDemonte' });
    }
    if (message.indexOf('FORBIDDEN_TO_UNARCHIVE_FACE_IF_MATERIEL_ARCHIVED') === 0) {
      messages.push({ message: 'detailFace.messages.error.desarchivageImpossible' });
    }
  });
}
